import { animate, state, style, transition, trigger } from '@angular/animations';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject, interval, of } from 'rxjs';
import { ShipyardService } from 'src/app/modules/shipyard/shipyard.service';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { HeaderService } from '../header/header.service';
import { filter, takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { ChangeDraftShipmentNamePopupComponent } from 'src/app/modules/shipyard/change-draft-shipment-name-popup/change-draft-shipment-name-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { CreateWalmartShipmentPayload, WalmartShipResponse } from 'src/app/models/walmart.model';
import { WalmartService } from 'src/app/services/walmart.service';
import { Router } from '@angular/router';
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoginModel } from 'src/app/models/login.model';
import { UpgradeFeemiumDialogComponent } from 'src/app/modules/shipyard/upgrade-feemium-dialog/upgrade-feemium-dialog.component';
import { CreateShipmentConfirmDialogComponent } from '../create-shipment-confirm-dialog/create-shipment-confirm-dialog.component';
import { CreateShipmentPopupComponent } from '../create-shipment-popup/create-shipment-popup.component';

@Component({
  selector: 'app-plan-preview',
  templateUrl: './plan-preview.component.html',
  styleUrls: ['./plan-preview.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class PlanPreviewComponent extends DataSource<any> implements  OnChanges,OnDestroy  {
  dataSource;
  _shipmentPlans: any;
  showBoader: number;
  isAnyShipmentCreated: boolean = false;
  shipmentPlanPreview: any[] = [];
  isAddAll: boolean= false;
  loading:boolean;
  destinationId: string;
  get shipmentPlans() {
    return this._shipmentPlans;
  }
  @Input() set shipmentPlans(value) {
    this._shipmentPlans = value;
  }
  @Input() skusToAddToShipment;
  @Input() isShow;
  @Input() isWalmart;
  @Input() isNewView : boolean = false;
  @Input() isCaseQty;
  @Input() isPrepAMZ: 'true' | 'false' = 'false';
  @Input() warehouse;
  @Input() account;
  @Input() planShipmentForm;
  @Input() isAdvanceWalmart;
  @Input() isBound;
  @Input() searchWarehouseId;
  @Input() exactMatch;
  @Input() selectedAddress;
  @Input() selectedTargetFC;

  plans:any;
  userInfo:LoginModel;
  _shipmentCreated:boolean = false;
  get shipmentCreated() {
    return this._shipmentCreated;
  }
  @Input() set shipmentCreated(value) {
    this._shipmentCreated = value;
    if(value){
      this.shipmentPlans.filter((res)=> res.disableCheckbox = false);
      this.isAnyShipmentCreated = true;
    }      
  }
  master_checked: boolean = false;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Output() onQtyChange: EventEmitter<any> = new EventEmitter();
  disableCheckbox:boolean=false;
  refresh:boolean=false;

  displayedColumns = ['checked','destinationId','skus', 'qty', 'shipTo','millage','fees','shipmentId','AddAllHere','export','create'];
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');
  expandedElement: any;
  private destroy$ = new Subject<void>();
  progressbarValue = 0;
  curSec: number = 120;
  timer$;
  isShowProgress:boolean=false;
  processStart:boolean=false;

  constructor(
    public shipyardService : ShipyardService,
    private snackBar: MatSnackBar,
    private headerService:HeaderService,
    private datepipe:DatePipe,
    private dialog:MatDialog,
    private walmartService:WalmartService,
    private router:Router,
    private gridActionService:GridActionsService,
    private authService:AuthService
  ) {
    super();
    //Handling AddAllHere Signalr Response
    this.headerService.remoteActionBroadcaster.pipe(filter((e) => e.action === "Add All Here"),takeUntil(this.destroy$)).subscribe((e) => {  
      const planIdx = this.shipyardService.planProcess?.findIndex((res)=>res.id == e.id); 
      const planDestinationIdx = this.shipyardService.planProcessWithDestination?.findIndex((res)=>res.id == e.id);  
      if ((e.response.responseType === "done" || e.response.responseType === "error") && (planIdx != -1 || planDestinationIdx != -1)) {  
        if(this.shipmentPlans?.length > 0 && planIdx != -1)
        { 
          this.shipmentPlans = [];
          this.shipmentPlans = this.shipyardService.planProcess[planIdx].shipmentPlans;
          let selectedPlanIdx = this.shipmentPlans?.findIndex((item) => this.shipyardService.planProcess[planIdx]?.shipmentId == item.shipmentId);            
          if (selectedPlanIdx !== -1){
            this.shipmentPlans[selectedPlanIdx].loader = false;
            this.shipmentPlans[selectedPlanIdx].checked = false;
            this.shipmentPlans[selectedPlanIdx].checkBoxDisable = false;
            this.shipmentPlans[selectedPlanIdx].disable = false;
          }
          this.shipyardService.planProcess.splice(planIdx,1);
        } 
        this.master_checked = this.shipmentPlans.filter(res=>!res.checked).length == 0;
        this.onChangeEvent.emit({showError: !this.master_checked, isAnySelectedPlan:false});
        if(this.shipmentPlanPreview?.length > 0 && planDestinationIdx != -1)
        {            
          let selectedPlanIdx = this.shipmentPlanPreview?.findIndex((item) => this.shipyardService.planProcessWithDestination[planDestinationIdx].destinationId == item.destinationId);            
          if (selectedPlanIdx !== -1){
            this.shipmentPlanPreview[selectedPlanIdx].disable = false;
            this.shipmentPlanPreview[selectedPlanIdx].loader = false; 
          } 
          this.refresh=true;
          this.shipyardService.planProcessWithDestination.splice(planDestinationIdx,1);
        }

        if(!this.shipyardService.planProcessWithDestination.length && !this.shipyardService.planProcess.length){
          this.progressbarValue=100;
          this.processStart=false;
        }
                     
        if (e.response.responseType === "error") {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 30000,
            horizontalPosition: "center",
            data: {
              title:  e?.response?.message,
              action: "Dismiss",
              type: "error",
            },
          });
        }
      } else if (e?.response?.data) {
        this.loading = true;
        if(planIdx != -1){ 
          let shipmentPlansRespone = e.response.data;
          this.getLocationByMatch(shipmentPlansRespone);              //get highest match percentage with destination Id
          this.sortingPlan(shipmentPlansRespone.shipmentId);                                        //sorting bu PctMatch 
          this.getShipmentName(shipmentPlansRespone);               //get ShipmentName            //get ShipmentName
        }

        if(planDestinationIdx != -1){
          this.refresh=false;
          let shipmentPlansRespone = e.response.data
          let selectedPlanIdx = this.shipmentPlanPreview?.findIndex((item) => this.shipyardService.planProcessWithDestination[planDestinationIdx].destinationId == item.destinationId && planDestinationIdx != -1 && this.shipyardService.planProcessWithDestination[planDestinationIdx].destinationId == shipmentPlansRespone.destinationId);                         
          if(selectedPlanIdx != -1){
            if(selectedPlanIdx != -1 && this.shipmentPlanPreview[selectedPlanIdx].pctMatch.pctMatch < 100 && this.shipmentPlanPreview[selectedPlanIdx].pctMatch.pctMatch < shipmentPlansRespone.pctMatch.pctMatch){
                 this.getLocationByMatch(shipmentPlansRespone);
                 this.shipmentPlanPreview[selectedPlanIdx].pctMatch.pctMatch = shipmentPlansRespone.pctMatch.pctMatch;
                 this.shipmentPlanPreview[selectedPlanIdx].shipmentId = shipmentPlansRespone.shipmentId;
                 let date = new Date();
                 let currentDate = this.datepipe.transform(date, 'MM/dd/yy hh:mm:ss a');
                 this.shipmentPlanPreview[selectedPlanIdx].shipmentName = "FBA-(" + currentDate + ")-" + selectedPlanIdx;
                 this.refresh=true;
                 this.shipmentPlanPreview[selectedPlanIdx].disable = true;
                 this.shipmentPlanPreview[selectedPlanIdx].loader = true; 
              }
            }
        } 
      }       
    })

    //Handling ConfirmShipmentPlan Signalr Response
    this.headerService.remoteActionBroadcaster.pipe(filter((e) => e.action === "ConfirmShipmentPlan"),takeUntil(this.destroy$)).subscribe((e) => {
     const createShipIdx = this.shipyardService.createShipment?.findIndex((res) => res.id == e.id);
      const createShipPlan = this.shipyardService.createShipment?.filter((res) => res.id == e.id);

      if(e?.response?.data || e.response.responseType === "error"){        
        if(createShipIdx !== -1 && this.shipyardService.createShipment[createShipIdx].isPlanPreview){
        this.shipyardService.loadCreateShipment = false;          
          this.shipmentPlans[createShipPlan[0].index].loadCreateButton = false;
          this.shipmentPlans[createShipPlan[0].index].disableShipmentName = true;  
          this.shipyardService.createShipment.splice(createShipIdx, 1);
          if (e?.response?.data) {
            const result=e?.response?.data;
            result?.forEach((res)=>{
              this.createShipmentRenderer(res,createShipPlan[0]);
            })
          }
        }
      }
    });
    this.authService.userInfo$.pipe(takeUntil(this.destroy$)).subscribe((userInfo) => {
      this.userInfo = userInfo;
    });
  }

  startTimer(seconds: number) {
      this.timer$ = interval(1000);
      const sub = this.timer$.pipe(takeUntil(this.destroy$)).subscribe((sec) => {
        this.progressbarValue = Number(((sec * 100) / seconds).toFixed());
        this.curSec = sec;  
        if (this.curSec === seconds || !this.processStart) {          
          sub.unsubscribe();
          this.progressbarValue=100;
        }
      });
  }

  ngOnDestroy(): void {
    this.shipyardService.loadCreateShipment=false;
    this.shipmentPlanPreview = [];
    this.destroy$.next();
    this.destroy$.unsubscribe(); 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isAdvanceWalmart) {
      if (this.shipmentPlans?.length || this.skusToAddToShipment?.length) {
          this.dataSource = this.connect();
      }
      if (!this.isShow) {
            this.displayedColumns = this.displayedColumns.filter(col => col !== 'shipmentId' && col !== 'create' && col !== 'fees');
        } else {
            this.addOrRemoveColumn('shipmentId', 6);
            this.addOrRemoveColumn('AddAllHere', 8);
            this.filterDisplayedColumnsForView();
        }
        if (this.isWalmart) {
            this.displayedColumns = this.displayedColumns.filter(col => col !== 'checked' && col !== 'create' && col !== 'fees');
        }
        if (this.shipmentPlans?.length) {
            this.isAddAll = this.shipmentPlans.some(plan => plan.planCreated && plan.success);
            this.showBoader = this.shipmentPlans.some(plan => plan.planCreated);
        }
      } else {
        if (this.shipmentPlans.payload[0].previews[0].preview?.length || this.skusToAddToShipment.length) {
            this.dataSource = this.connect(this.isBound);
        }

        if ( this.isBound) {
          this.displayedColumns = this.displayedColumns.filter(col => col !== 'checked' && col !== 'shipmentId' && col !== 'export');
        }else{
          this.displayedColumns = this.displayedColumns.filter(col => col !== 'checked' && col !== 'shipmentId' && col !== 'create' && col !== 'export' && col !== 'fees');
        }
      
        this.removeColumns(['AddAllHere', 'shipmentHeaderId']);
    }
  }


  addOrRemoveColumn(columnName: string, position: number): void {
      const index = this.displayedColumns.findIndex(col => col === columnName);
      if (index === -1) {
          this.displayedColumns.splice(position, 0, columnName);
      }
  }

   filterDisplayedColumnsForView(): void {
      this.displayedColumns = this.displayedColumns.filter((col, index) => {
          if ((col === 'checked' || col === 'fees') && this.isNewView) {
              return false;
          } else if (col === 'create' && !this.isNewView) {
              return false;
          }
          return true;
      });
  }

   removeColumns(columns: string[]): void {
      this.displayedColumns = this.displayedColumns.filter(col => !columns.includes(col));
  }


  connect(isInbound?): Observable<any[]> {
    const rows = [];
    if(!this.isAdvanceWalmart){
      return this.handleNonAdvanceWalmartMode(rows);
    }else{
      return this.handleAdvanceWalmartMode(isInbound, rows);
    }
  }

   handleNonAdvanceWalmartMode(rows: any[]): Observable<any[]> {
    const dataToProcess = this.shipmentPlans?.length ? this.shipmentPlans : this.skusToAddToShipment;
    if (dataToProcess) {
      if(this.shipmentPlans?.length){
        let index=this.shipmentPlans.findIndex(res=> !res.checked);
        if(index == -1 && !this.isShow){
          this.disableCheckbox=true
        }
      }     
        dataToProcess.forEach((element: any, i: number) => {
            element.isExpend = false;
            if (element.skus) {
                element.skus.sort((a, b) => a.Sku?.localeCompare(b.Sku));
            }
            if (dataToProcess.length === i + 1) element.hideBorder = true;
            rows.push(element, { detailRow: true, element });
        });

        if (this.master_checked && this.shipmentPlans?.length) {
            this.setSelectAll();
        }
    }
    return of(rows);
}

 handleAdvanceWalmartMode(isInbound: boolean, rows: any[]): Observable<any[]> {
    const previewIndex = isInbound ? 0 : 1;
    const plans = this.shipmentPlans?.payload[0]?.previews[previewIndex]?.preview || [];
    
    plans.forEach((element: any, i: number) => {
        element.qty = element.shipmentItems.reduce((prev, next) => prev + next.itemQty, 0);
        element.shipTo = `${element.shipToAddress.city}, ${element.shipToAddress.stateCode}, ${element.shipToAddress.countryCode}`;
        this.bindSkuDetail(Object.assign({}, element), i, isInbound);
        element.isExpend = false;
        element.shipmentItems.sort((a, b) => a.vendorSku.localeCompare(b.vendorSku));
        if (plans.length === i + 1) element.hideBorder = true;
        rows.push(element, { detailRow: true, element });
    });

    return of(rows);
}
  disconnect(collectionViewer: CollectionViewer): void {    
  }

  openOnAmazon(amazonShipmentId) {
    window.open(
      `https://sellercentral.amazon.com/fba/inbound-shipment/summary/${amazonShipmentId}`,
      "_blank"
    );
  }

  setSelectAll(event?) {
    if(event) this.master_checked = event.checked;
    this.shipmentPlans.forEach((res)=>{
      if(!res.shipmentHeaderId)
      res.checked=this.master_checked;
    });
    this.onChangeEvent.emit({showError: !this.master_checked, isAnySelectedPlan:this.master_checked});
  }

  selectSku(event){
    let index=this.shipmentPlans.findIndex(res=> !res.checked);
    if(index !== -1){
      this.master_checked =false;
    } else{
      this.master_checked =true;
    }
    if(event.checked){
      this.onChangeEvent.emit({showError: !this.master_checked, isAnySelectedPlan:true});
    } else{
      let selectedPlanIdx=this.shipmentPlans.findIndex(res=> res.checked && !res.shipmentHeaderId);
      this.onChangeEvent.emit({showError: !this.master_checked, isAnySelectedPlan:selectedPlanIdx !== -1 ? true : false});
    }    
  }

  removeItem(item) {
    const idx = this.skusToAddToShipment.findIndex(currentItem => item.sku.AccountSkuId === currentItem.sku.AccountSkuId);
    if(idx != -1){
      this.skusToAddToShipment.splice(idx,1);
      this.skusToAddToShipment.items -= 1;
      this.skusToAddToShipment.qty -= item.qty;
    }
  }

  updateqty(){
    let sku = this.skusToAddToShipment.filter(currentItem =>{
      return currentItem.qty < 1;
    });
    if(sku.length == 0){
      let updatedQty = 0;
      this.skusToAddToShipment.forEach((res)=>{
        updatedQty += res.qty;
      })
      this.skusToAddToShipment.qty = updatedQty;
      this.onQtyChange.emit(false)
    } else{
      this.onQtyChange.emit(true)
    }    
  }

  toggleRow(element) {
    if(this.isAdvanceWalmart && this.isBound){
      this.toggleRowForInbound(element,0);
    }else if(this.isAdvanceWalmart && !this.isBound){
      this.toggleRowForInbound(element,1);
    }else{
      this.shipmentPlans?.forEach((res:any,i) => {
        if(res.shipmentId == element.shipmentId){
          res.expanded=!element.expanded
        }     
      });
    }
  }

  toggleRowForInbound(element,value){
    this.shipmentPlans.payload[0]?.previews[value]?.preview?.forEach((res:any,i) => {
      if(res.shipToAddress.fcName == element.shipToAddress.fcName){
        res.expanded=!element.expanded
      }     
    });
  }

  updateCaseQty(event){
    this.skusToAddToShipment.filter((res,i)=>{
      if(res.sku.Sku  == event.Sku){
        event.isCaseQty ? this.skusToAddToShipment[i].sku.CaseQty = Number(event.qty) :  this.skusToAddToShipment[i].qty =  Number(event.qty);
      }else if(!res.sku.CaseQty && event.isCaseQty){
        this.skusToAddToShipment[i].sku.CaseQty = 1;
      }
    })
    this.updateqty();
  }

  restrictSpecialChar(event) {
    let k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k == 32) || (k >= 39 && k <= 57));
  }

  AddAllHere(element){
    if(this.isNewView){      
      this.AddAllHereNew(element);
    }else{
      this.AddAll(element);
    }
   }

  AddAllHereNew(element){
    this.loading = true;
    this.isShowProgress=true;
    if(this.shipmentPlans?.length > 0){
      let selectedPlanIdx = this.shipmentPlans.findIndex((item)=>element.destinationId == item.destinationId);
      if(selectedPlanIdx !== -1) this.shipmentPlans[selectedPlanIdx].loader = true;
    }
       this.shipmentCreated = false;
   
    const payload:any = {
      shipmentId: element.shipmentId,
      account:this.account[0],
      searchWareHouseId:this.searchWarehouseId,
      AddQty : true,
      ExactMatch: this.exactMatch
    }
    if(this.skusToAddToShipment.FbaType && this.skusToAddToShipment.FbaType !== 'All'){
      payload.shipmentType = this.shipyardService.getShipmentTypeId(this.skusToAddToShipment.FbaType)
    }
    if(this.selectedTargetFC && this.selectedAddress){
      payload.targetFulfillmentCenterId=this.selectedTargetFC.fulfillmentCenterId
      payload.fromAddress={
        add1: this.selectedAddress.add1,
        city: this.selectedAddress.city,
        state: this.selectedAddress.state,
        zip: this.selectedAddress.zip,
        country: this.selectedAddress.country
      }
    }
    this.shipyardService.PlanAddAllHere(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.processStart=false;
        setTimeout(()=>{
          this.startTimer(120);
          this.progressbarValue=0;
          this.processStart=true;
        },1000)
        this.shipyardService.planProcess.push(
        {
            id:res.id,
            shipmentId:element.shipmentId,
            shipmentPlans:this.shipmentPlans
        });
     
        let selectedPlanIdx = this.shipmentPlans.findIndex((item)=>element.destinationId == item.destinationId);
        if(selectedPlanIdx !== -1){
          this.shipmentPlans[selectedPlanIdx].disable = true;
          this.shipmentPlans[selectedPlanIdx].checkBoxDisable = true;
        }
        if(this.shipmentPlans.filter(res=>res.loader).length == 0)  this.loading = false;
      },
      error: (err) => {
       let selectedPlanIdx = this.shipmentPlans.findIndex((item)=>element.destinationId == item.destinationId);
       if(selectedPlanIdx !== -1){
         this.shipmentPlans[selectedPlanIdx].loader = false;
       }
       if(this.shipmentPlans.filter(res=>res.loader).length == 0)  this.loading = false;
     }
   });
  }


  AddAll(element){ 
    this.shipmentPlans.forEach((res)=>{
      if(res.destinationId == element.destinationId){
        res.checked = true;
      }
      else{
        res.checked = false;
        this.master_checked = false;
        res.disableCheckbox = true;         
        this.disableCheckbox = true;
      }
    }); 
    this.shipmentCreated = false;
    this.onChangeEvent.emit({showError: !this.master_checked, isAnySelectedPlan:true});
    this.planAllHere(element);
}

  planAllHere(element){    
    let selectedPlanIdx = this.shipmentPlans.findIndex((item)=>element.destinationId == item.destinationId);
    if(selectedPlanIdx !== -1) this.shipmentPlans[selectedPlanIdx].loading = true;
    let skusToAddToShipment = this.skusToAddToShipment.map((e) => {

      return {
        sku: e.sku.Sku,
        qty: this.isCaseQty ? e.Qty * e.CaseQty : e.qty,
        caseQty: this.isCaseQty ? e.Qty : null,
      };
    });
    
    const formValue = {
      skus: skusToAddToShipment,
      fromWareHouseId: this.warehouse,
      isPrepAMZ: this.isPrepAMZ === 'true' ? true : false,
      shipmentId: element.shipmentId
    };
    this.shipyardService.PlanShipSp(formValue).pipe(takeUntil(this.destroy$)).subscribe({
      next: (e: { errors: any[]; shipmentPlans: any }) => {
        if(selectedPlanIdx !== -1) this.shipmentPlans[selectedPlanIdx].loading = false;               
        if (e.errors && e.errors.length) {
          if(selectedPlanIdx !== -1){
            this.shipmentPlans[selectedPlanIdx].error = true;
          }
          this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 5000,
            horizontalPosition: 'center',
            data: {
              title:  'Failed to add all. Please plan again and try another FC',
              action: 'Dismiss',
              type: 'error',
            },
          });
        } else if (e.shipmentPlans) {
          this.shipyardService.ShipIdChange = e.shipmentPlans[0];
          this.shipmentPlans[selectedPlanIdx].success = true;
          this.isAddAll = true
          this.shipmentPlans[selectedPlanIdx].success = true;
            let idx = this.shipmentPlans.findIndex((item)=>item.destinationId == element.destinationId);
            if(idx !== -1 ) {
              e.shipmentPlans[0].skus.filter((resSkus)=>{
                let skuIdx = this.shipmentPlans[idx].skus.findIndex((planSkus)=>planSkus.Sku == resSkus.sku);
                if(skuIdx !== -1) {
                 
                  var oldQty = this.shipyardService.skusToAddToShipment.find(x => x.sku.Sku == resSkus.sku)
                  
                 // let oldQty = this.shipmentPlans[idx].skus[skuIdx].Qty;
                  this.shipmentPlans[idx].skus[skuIdx].Qty = resSkus.qty;
                  this.shipmentPlans[idx].skus[skuIdx].qtyDif = resSkus.qty - oldQty.qty;
                }
              })
            }
            
          if(e.shipmentPlans?.length > 0)
    
          this.shipmentPlans.forEach((res)=>{
          res.qty = res.skus.reduce((prev,next)=>prev+next.Qty,0)
          });
        } else {
          if(selectedPlanIdx !== -1) this.shipmentPlans[selectedPlanIdx].error = true;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 5000,
            horizontalPosition: 'center',
            data: {
              title:  "An unknown error occurred. please try again.",
              action: 'Dismiss',
              type: 'error',
            },
          });
        }
      },
     error: (err) => {
        if(selectedPlanIdx !== -1){
          this.shipmentPlans[selectedPlanIdx].error = true;
          this.shipmentPlans[selectedPlanIdx].loading = false;
        }
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 30000,
            horizontalPosition: 'center',
            data: {
              title:  err.error["error"][0],
              action: 'Dismiss',
              type: 'error',
            },
        });
      }
   });
  }
  
  getLocationByMatch(shipmentPlansRespone){
    let response=Object.assign({},shipmentPlansRespone)
    if(this.shipmentPlanPreview.length){
      let idx = this.shipmentPlanPreview?.findIndex((res)=> res.destinationId === response.destinationId);
      if(idx !== -1){
        if(response.pctMatch.pctMatch > this.shipmentPlanPreview[idx].pctMatch.pctMatch){
          this.shipmentPlanPreview[idx] = response;
        }
        // else{          
        //   this.shipmentPlanPreview[idx].skus?.forEach((element:any,i) => {
        //     let index=response.skus.findIndex(res=>element.Sku === res.sku);
        //     if(index != -1){
        //       element.qty=response.skus[index].qty;
        //     }
        //   });
        // }
      }else{
        this.shipmentPlanPreview.push(response);
      }
    }else{
      this.shipmentPlanPreview.push(response);
    }
  }

  sortingPlan(shipmentId){
    let destinationArray = [];
    let sortedArray = [];
    this.shipmentPlanPreview.forEach(res => {
        if (res.shipmentId === shipmentId) {
            destinationArray.push(res);
        } else {
            sortedArray.push(res);
        }
    });
    const sortDescendingByMatch = (a, b) => b.pctMatch.pctMatch - a.pctMatch.pctMatch;
    destinationArray.sort(sortDescendingByMatch);
    sortedArray.sort(sortDescendingByMatch);
    this.shipmentPlanPreview = [...destinationArray, ...sortedArray];
  }

  getShipmentName(shipmentPlansRespone){
    if(shipmentPlansRespone){           
      this.shipmentPlanPreview.forEach((result,i)=>{
        let date = new Date();
        let currentDate = this.datepipe.transform(date, 'MM/dd/yy hh:mm:ss a');
        result.shipmentName = "FBA-(" + currentDate + ")-" + i;
     }) 
    }
    else if(shipmentPlansRespone.Error.length){
      this.loading = false;
      this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 30000,
        horizontalPosition: 'center',
        data: {
          title: shipmentPlansRespone.Error[0].reason,
          action: 'error',
          type: 'success',
        },
      });
    }
  }
  
  bindSkuDetail(plan,planIdx,isInbound) {
    this.shipmentPlans.payload[0].previews[isInbound ? 0 : 1].preview[planIdx].shipmentItems = [];
    plan.shipmentItems.forEach((res: any,skuIdx) => {
      const sku = this.skusToAddToShipment.filter((sku: any) => sku.sku.Sku === res.vendorSku);
      if (sku.length !== 0) {
        sku[0].sku.qty = res?.itemQty,
        sku[0].sku.currencyUnit= res?.currencyUnit;
        sku[0].sku.itemQty= res?.itemQty;
        sku[0].sku.netTransferCharge= res?.netTransferCharge;
        sku[0].sku.productId= res?.productId;
        sku[0].sku.productType= res?.productType;
        sku[0].sku.vendorSku= res?.vendorSku;
        sku[0].sku.qtyDif= sku[0].qty-res?.itemQty;
        this.shipmentPlans.payload[0].previews[isInbound ? 0 : 1].preview[planIdx].shipmentItems.push(Object.assign({},sku[0].sku))
      }
    })
  }

  createWalmart(isInbound = false){
    if (this.userInfo.isShipyard === 2 || this.userInfo.freemiumAvail) {
      this.createPlan(isInbound);
     
    }else{
      this.upgradeToPremium(isInbound);
    }

  }
  createPlan(isInbound = false) {
    const dialog =  this.dialog
      .open(ChangeDraftShipmentNamePopupComponent, {
        width: "400px",
        data: {
          title: "Create Shipment",
          label: `Name`,
          isWalmart:true,
          confirmationButton: "Create",
          callBackFn: (dialogRef, actions,shipmentName) => {
            if (shipmentName === "" || shipmentName) {             
              const skusToAddToShipment = this.skusToAddToShipment.map((e) => {
                return {
                  sku: e.sku.Sku,
                  accountSkuId:e.sku.AccountSkuId,
                  qty: this.isCaseQty ? e.qty : e.qty,
                  caseQTY: this.isCaseQty ? e.sku.CaseQty : null,
                  cases: this.isCaseQty ? e.qty  / e.sku.CaseQty : null
                };
              }); 
              const payload: CreateWalmartShipmentPayload = {
                account: this.account[0],
                fromWareHouseId: this.planShipmentForm.value.fromWareHouseId.id,
                skus: skusToAddToShipment,
                shipmentName :shipmentName,
                inventoryTransferService : isInbound ? 'Y' : 'N'
              };
              this.createWShipment(payload,dialogRef, actions)
            }
          },
        },
      });
      dialog
      .afterClosed()
      .pipe(filter((e) => e === "Create"))
      .subscribe();    
  }

  createWShipment(payload,dialogRef, actions){
    this.walmartService.CreateMultiWShipment(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: WalmartShipResponse[]) => {
      if(res){
        this.shipyardService.skusToAddToShipment = [];
        this.skusToAddToShipment = [];
        if (dialogRef) dialogRef.close();
        if (actions) actions[1].spin = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 6000,
            horizontalPosition: 'center',
            data: {
              title: 'Shipment has been created successfully.',
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
        this.router.navigate(["/shipyard/shipments/detail/", res[0].shipmentHeaderId]);
      }
      },
       error: (err) => {
        if (actions) {
          actions[1].spin = false;
        }
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 30000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
      },
     complete: () => {
        if (dialogRef) {
          dialogRef.close();
        }
      }
     },
    );
  }

  create(shipment){
    if (this.userInfo.isShipyard === 2 || this.userInfo.freemiumAvail) {
      this.createShipment(shipment)
    }else{
      this.upgradeToPremium(shipment);
    }
  }

  createShipment(shipment){
    this.dialog
      .open(CreateShipmentConfirmDialogComponent, {
        width: "400px",
        data:{
          title: "Create Shipment",
          shipment
        }
      })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe(() => {
        this.shipyardService.loadCreateShipment = true;
        let selectedPlanIdx = this.shipmentPlans.findIndex((item)=>shipment.shipmentId == item.shipmentId);
        this.shipmentPlans[selectedPlanIdx].loadCreateButton = true;
        const skus  = {
          shipmentPlanHeaderId: shipment.shipmentPlanHeaderId,
          shipmentId: shipment.shipmentId,
          shipmentName: shipment.shipmentName,
          isOriginal: true
          
        };
        const confirmShipmentSpPayload={
          shipmentPlanRequests:[skus]
        }
        this.shipyardService
        .ConfirmShipmentSp(confirmShipmentSpPayload)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
            next: (e:any) => {
          this.shipyardService.planProcess=[];
          this.shipyardService.planProcessWithDestination=[];
          this.resetLoading(); 
            if(e){
                this.shipyardService.createShipment.push({
                id:e.id,
                index: selectedPlanIdx,
                shipmentPlan: this.shipmentPlans,
                isPlanPreview:true
               });          
            }
          },
           error: (err) => {
            this.shipyardService.loadCreateShipment = false;
            this.shipmentPlans[selectedPlanIdx].loadCreateButton = false;
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 3000,
              horizontalPosition: "center",
              data: {
                title: err?.error?.error[0],
                action: "Dismiss",
                type: "error",
              },
            });
          }
         });
      });
  }

  createShipmentRenderer(e, createShipPlan){
    this.shipyardService.ShipIdChange = null; 
  if(e.isSuccess && e.isSynced){      
    this.shipmentPlans[createShipPlan.index].planCreated = true;
    this.shipmentPlans[createShipPlan.index].shipmentHeaderId = Number(e.shipmentHeaderId);
    this.shipmentPlans[createShipPlan.index].shipmentId = e.shipmentId;
    this.assignFreemium(Number(e.shipmentHeaderId));
    const skus = this.shipmentPlans[createShipPlan.index].skus.map((data) => {
      return data.AccountSkuId
    });
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 3000,
      horizontalPosition: "center",
      data: {
        title: "Shipments has been created successfully",
        action: "Dismiss",
        type: "success",
      },
    });
  } else if((!e.isSuccess && !e.isSynced) || (e.isSuccess && !e.isSynced)){    
    this.shipmentPlans[createShipPlan.index].loading = false;     
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 3000,
      horizontalPosition: "center",
      data: {
        title: (e.isSuccess && !e.isSynced) ? e.syncErrorMessage : e.errorMessage,
        action: "Dismiss",
        type: (e.isSuccess && !e.isSynced) ? "info" : "error", 
      },
    });
  }
}

  assignFreemium(shipmentHeaderId){
    if(this.userInfo.isShipyard === 1 && this.userInfo.freemiumAvail){
      this.shipyardService.AssignFreemium(shipmentHeaderId).pipe(takeUntil(this.destroy$)).subscribe((res)=>{
        this.shipyardService.updateLocalStorageKey(
          "freemiumAvail",
          res
        );
      })
    }
  }

  startProgress(){
    this.processStart=false;
    setTimeout(()=>{
      this.startTimer(120);
      this.progressbarValue=0;
      this.processStart=true;
    },1000)
  }

  exportShipment(element){
    this.shipyardService.exportShipmentPlan(element.shipmentId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (e) => {
          this.gridActionService.downloadBlob(
            e.body,
            null,
            ('Planshipment') + ".csv"
          );
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: 'Shipment Plan has been Exported Successfully',
              action: "Dismiss",
              type: "success",
            },
          });
        },
      error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: "center",
              data: {
                title: err?.error?.error[0],
                action: "Dismiss",
                type: "error",
              },
            }
          );
      }
    });
  }
  
  resetLoading(){
    if(this.shipyardService.planProcess.length === 0){
      this.shipmentPlans.forEach((result)=>{
       result.loader = false;
       result.checked = false;
       result.checkBoxDisable = false;
       result.disable = false;
      })
    }
    if(this.shipyardService.planProcessWithDestination.length === 0){
      this.shipmentPlanPreview.forEach((result)=>{
        result.loader = false;
        result.disable = false;
       })
    }
    if(!this.shipyardService.planProcessWithDestination.length && !this.shipyardService.planProcess.length){
      this.progressbarValue=100;
      this.processStart=false;
    }
  }
  upgradeToPremium(shipment) {
    this.dialog
      .open(UpgradeFeemiumDialogComponent, {
        width: "500px",
      })
      .afterClosed()
      .pipe(filter((e) => e === "Continue"))
      .subscribe(() => {
        if(this.isAdvanceWalmart){
          this.createPlan(shipment);
        }else{
          this.createShipment(shipment);
        }
      });
  }

  copy(e,element) {
    element.copied = true;
    setTimeout(() => {
      element.copied = false;
    }, 800);
  }

  createAll(){
    this.dialog
      .open(CreateShipmentPopupComponent, {
        hasBackdrop: false,
        width: "650px",
        data:{
          isPlanPreview:true,
          shipment:this.shipmentPlans
        }
      })
  }
}

